const CYRILLIC_REG_EXP = /[А-Яа-яёЁ]/

const PASSWORD_REG_EXP =
  /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$&*%)(+-/;:<=>?[^\]_{|}~])/

const AVAILABLE_PHONE_COUNTRIES: CountryCodes[] = [
  'RU',
  'BY',
  'KZ',
  'AZ',
  'AM',
  'KG',
  'TJ',
  'UZ',
  'TM',
]

export { CYRILLIC_REG_EXP, PASSWORD_REG_EXP, AVAILABLE_PHONE_COUNTRIES }
